<script setup>

import CreditCardRow from '../components/CreditCardRow.vue';
import { onBeforeMount, onMounted } from "vue";
import setTooltip from "../assets/js/tooltip";
import router from "../router";
import cookie from '../assets/js/cookies.js';
import validSession from "../assets/js/valid-session.js";
import bootstrap from "bootstrap/dist/js/bootstrap";
import { useStore } from "vuex";
import axios from "axios";
import { toast } from 'vue3-toastify';
import loadGif from "@/assets/img/loading.gif"
import SkeletonLoad from '../components/SkeletonLoad.vue';
import { computed } from "vue";
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const getIcons = async () => {

    axios.get('bank-icons?type=credit')
    .then(res => {
        
        if(res.status == 200){

            store.state.icons = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

const value_limit = {
    value: 0
};

const money = {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false /* doesn't work with directive */
        }

onBeforeMount(() => {

    validSession.isLogged();

    store.state.validation = {
        nameHasError: false,
        nameMessageError: '',
        accountHasError: false,
        accountMessageError: '',
    };

    store.state.card = {
        icon: 'https://assets.agive.com.br/financas/cartoes/credit-card-logo.png',
        name: '',
        limit: 0,
        close_day: 1,
        due_day: 1,
        account: "",
        id: ''
    };

    store.state.card_details = {
        icon: '',
        name: '',
        limit: 0,
        limit_used: 0,
        close_day: 1,
        due_day: 1,
        account: "",
        id: ''
    };

    store.state.icons = [];
    store.state.accounts = [];
    store.state.cards = [];
    store.state.invoices = [];
    store.state.qtdInvoices = 0;
    store.state.loadingCards = true;
    store.state.savingCard = false;
    store.state.editBalance = false;

    store.state.toArchive = {
        icon: '',
        name: '',
    };

    store.state.selectedYear = new Date().getFullYear();

    getIcons();

    store.state.loadingCards = true;
    getCards();
    getAccounts();
  
})

onMounted(() => {
    setTooltip();

    let session = cookie.get('user_agive_session');

    if(session == null){
        router.push({name: 'Login'});
    }

});

const clearFields = () => {

    value_limit.value = 0;

    store.state.card = {
        icon: 'https://assets.agive.com.br/financas/cartoes/credit-card-logo.png',
        name: '',
        not_sum: false,
        id: '',
        balance: 0
    };

    store.state.editBalance = false;

    store.state.toArchive = {
        icon: '',
        name: '',
    };
}

const getAccounts = async () => {

    store.state.loadingCards = true;

    axios.get('accounts?archived=No')
    .then(res => {
        
        if(res.status == 200){

            store.state.accounts = res.data;
            store.state.loadingCards = false;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getCards = async () => {

    axios.get('credit-cards')
    .then(res => {
        
        if(res.status == 200){

            store.state.cards = res.data;
            store.state.loadingCards = false;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const submitCard = async () => {

    store.state.savingCard = true;

    let data = new FormData();

    store.state.validation.nameHasError = false;

    store.state.card.limit = value_limit.value.replace('R$ ', '');

    data.append('name', store.state.card.name);
    data.append('icon', store.state.card.icon);
    data.append('limit', store.state.card.limit);
    data.append('close_day', store.state.card.close_day);
    data.append('due_day', store.state.card.due_day);
    data.append('account_id', store.state.card.account);

    let url = '/credit-cards';
    let toast_message = t('message.credit_cards.created');

    if(store.state.card.id != ''){

        url = '/credit-cards/update/'+store.state.card.id;
        toast_message = t('message.credit_cards.updated');
    }

    await axios.post(url, data)
    .then(res => {

        if(res.data.error){

            let messages = res.data.messages;

            Object.entries(messages).forEach((value) => {

                if(value[0] == 'name'){
                    store.state.validation.nameHasError = true;
                    store.state.validation.nameMessageError = value[1];
                }

                if(value[0] == 'account_id'){
                    store.state.validation.accountHasError = true;
                    store.state.validation.accountMessageError = value[1];
                }

            })

            store.state.savingCard = false;

        }
        else{

            store.state.validation = {
                nameHasError: false,
                nameMessageError: '',
            };

            closeModal('addCard');

            clearFields();

            toast(toast_message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

            store.state.savingCard = false;

            getCards();

        }

    })
    .catch(err => {
        console.error(err); 

        toast('Não foi possível realizar a operação, tente mais tarde (Erro '+err.response.status+')', {
            autoClose: 1000,
            theme: "auto",
            type: "error",
            transition: "slide"
        });

        store.state.savingCard = false;
    })

}

const editCard = (data) => {

    value_limit.value = formatMoney(data.limit);

    store.state.card = {
        icon: data.icon,
        name: data.name,
        limit: formatMoney(data.limit),
        close_day: data.close_day,
        due_day: data.due_day,
        account: data.account_id,
        id: data.id
    };

}

const archiveCard = async (card, archive) => {

    if(archive == 'Yes'){

        store.state.toArchive = {
            icon: card.icon,
            name: card.name,
        };

        openModal('confirmarchiveCard');

        var confirmButton = document.getElementById('confirmarchiveCardButton');
        confirmButton.addEventListener('click', async function () {
        // do something...
        
            let data = new FormData();

            data.append('archived', archive);

            let url = '/credit-cards/archive/'+card.id;
            let toast_message = t('message.credit_cards.archived');

            await axios.post(url, data)
            .then(res => {

                if(res.data.error){

                    console.log(res);

                }
                else{

                    toast(toast_message, {
                        autoClose: 1000,
                        theme: "auto",
                        type: "success",
                        transition: "slide"
                    });

                    closeModal('confirmarchiveCard');
                    
                    getCards();

                }

            })
            .catch(err => {
                console.error(err); 
            })
            

        })

    }
    else{

        let data = new FormData();

        data.append('archived', archive);

        let url = '/credit-cards/archive/'+card.id;
        let toast_message = t('message.credit_cards.desarchived');;

        await axios.post(url, data)
        .then(res => {

            if(res.data.error){

                console.log(res);

            }
            else{

                toast(toast_message, {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });

                closeModal('confirmarchiveCard');
                
                getCards();

            }

        })
        .catch(err => {
            console.error(err); 
        })

    }    

}

const deleteCard = async (card) => {

    store.state.toArchive = {
        icon: card.icon,
        name: card.name,
    };

    openModal('deleteCard');

    var confirmButton = document.getElementById('confirmExclusionAccountButton');
    confirmButton.addEventListener('click', async function () {
    // do something...

        let url = '/credit-cards/delete/'+card.id;
        let toast_message = t('message.credit_cards.deleted');

        await axios.post(url)
        .then(res => {

            if(res.data.error){

                console.log(res);

            }
            else{

                toast(toast_message, {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });

                closeModal('deleteCard');
                
                getCards();

            }

        })
        .catch(err => {
            console.error(err); 
        })
        

    })

}

const openInvoices = async(card) => {

    router.push('/cartao-de-credito/'+card);

}

const openModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.show();

}

const closeModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.hide();

}

function formatMoney(v) {
    let total = parseFloat(v);

    return total.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
        });
}

</script>
<template>
    <div class="py-4 container-fluid overflow-auto max-height-vh-90">
        <div class="row">
            <div class="col-12">

                <div class="card cards-premium-card border-0">
                    <div class="card-header cards-premium-header border-0">
                        <div class="cards-header-top">
                            <div class="cards-title-wrap">
                                <span class="cards-eyebrow">{{ t('message.menu.credit_card') }}</span>
                                <h3 class="cards-title">Cartões de crédito</h3>
                                <p class="cards-subtitle mb-0">Acompanhe seus cartões com mais clareza e uma visualização mais moderna.</p>
                            </div>

                            <div class="cards-header-actions">
                                <a 
                                    class="cards-add-btn"
                                    type="button" 
                                    id="dropdownMenuButton1"
                                    @click="openModal('addCard')"
                                >
                                    <i class="fal fa-plus-circle"></i>
                                    <span>{{ t('message.global.add') }}</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="card-body cards-premium-body">
                        <div class="cards-surface">
                            <div class="row">
                                <div class="col-11 mx-auto text-center mt-4 mb-4" v-if="store.state.loadingCards">
                                    <div class="row align-items-center">
                                        <div class="col-2 col-lg-1 ms-3">
                                            <SkeletonLoad
                                                :width='"50px"'
                                                :height="'50px'"
                                                :class="'rounded'"
                                            />
                                        </div>
                                        <div class="col-4">
                                            <SkeletonLoad
                                                :width="'150px'"
                                                :height="'20px'"
                                            />
                                        </div>
                                        <div class="col-5 col-lg-6 text-end"></div>
                                    </div>
                                </div>

                                <div class="cards-empty-state" v-if="store.state.cards.length == 0 && !store.state.loadingCards">
                                    <div class="cards-empty-icon">
                                        <i class="fal fa-credit-card"></i>
                                    </div>
                                    <div>
                                        <strong>Nenhum cartão cadastrado</strong>
                                        <p class="mb-0">{{ t('message.global.zero_cards') }}</p>
                                    </div>
                                </div>

                                <div class="col-12 mt-2 mb-2 cards-list-wrap" v-if="!store.state.loadingCards && store.state.cards.length >= 1">
                                    <CreditCardRow
                                        v-for="(card, index) in store.state.cards" :key="index"
                                        :card="card"
                                        :darkmode="darkMode"
                                        @edit="editCard"
                                        @archive="archiveCard"
                                        @delete="deleteCard"
                                        @open="openInvoices"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="addCard" tabindex="-1" aria-labelledby="addCard" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable card-modern-modal-dialog">
            <div class="modal-content card-modern-modal-content" v-bind:class="{
                                            'darkmode': darkMode,
                                        }">
                <div class="modal-body card-modern-modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="card-modern-modal-header">
                        <div>
                            <div class="card-modern-modal-eyebrow">Cartões de crédito</div>
                            <h4 class="card-modern-modal-title">
                                {{ store.state.card.id == '' ? t('message.credit_cards.new') : t('message.credit_cards.edit') }}
                            </h4>
                            <p class="card-modern-modal-subtitle">Cadastre o cartão, ajuste os dias de fechamento e vencimento e vincule uma conta.</p>
                        </div>
                        <button type="button" class="card-modern-close" data-bs-dismiss="modal" @click="clearFields()">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>

                    <div class="card-modern-preview-card">
                        <div class="card-modern-preview-icon">
                            <img :src="store.state.card.icon" alt="" class="img-fluid rounded-5">
                        </div>
                        <div class="card-modern-preview-text">
                            <span class="card-modern-preview-label">Pré-visualização</span>
                            <strong>{{ store.state.card.name || 'Nome do cartão' }}</strong>
                            <small>{{ value_limit.value && value_limit.value != 0 ? value_limit.value : 'Defina o limite do cartão' }}</small>
                        </div>
                    </div>

                    <div class="card-modern-form-card">
                        <div class="row g-3">
                            <div class="col-12">
                                <label for="cardName" class="card-modern-label">{{ t('message.credit_cards.name') }}</label>
                                <input 
                                    type="text" 
                                    class="form-control form-control-lg card-modern-input" 
                                    id="cardName"
                                    name="cardName"
                                    :placeholder="t('message.credit_cards.name')"
                                    v-model="store.state.card.name"
                                    v-bind:class="{
                                        'is-invalid': store.state.validation.nameHasError,
                                        'darkmode': darkMode,
                                    }"
                                >
                                <div id="cardNameFeedback" class="invalid-feedback">
                                    {{ store.state.validation.nameMessageError }}
                                </div>
                            </div>

                            <div class="col-12">
                                <label for="cardLimit" class="card-modern-label">{{ t('message.credit_cards.limit') }}</label>
                                <input 
                                    type="tel" 
                                    class="form-control form-control-lg card-modern-input" 
                                    id="cardLimit"
                                    name="cardLimit"
                                    :placeholder="t('message.credit_cards.limit')"
                                    v-model.lazy="value_limit.value" 
                                    v-money="money"
                                    v-bind:class="{
                                        'darkmode': darkMode,
                                    }"
                                >
                            </div>

                            <div class="col-6">
                                <label for="cardCloseDay" class="card-modern-label">{{ t('message.credit_cards.close_day') }}</label>
                                <select class="form-control form-control-lg card-modern-input"
                                    v-model="store.state.card.close_day"
                                    v-bind:class="{
                                        'darkmode': darkMode,
                                    }"
                                >
                                    <option v-for="n in 31" :key="n"
                                        :value="n"
                                    >
                                        {{n}}
                                    </option>
                                </select>
                            </div>

                            <div class="col-6">
                                <label for="cardDueDay" class="card-modern-label">{{ t('message.credit_cards.due_day') }}</label>
                                <select class="form-control form-control-lg card-modern-input"
                                    v-model="store.state.card.due_day"
                                    v-bind:class="{
                                        'darkmode': darkMode,
                                    }"
                                >
                                    <option v-for="n in 31" :key="n"
                                        :value="n"
                                    >
                                        {{n}}
                                    </option>
                                </select>
                            </div>

                            <div class="col-12">
                                <label for="cardAcount" class="card-modern-label">{{ t('message.credit_cards.account') }}</label>
                                <select class="form-control form-control-lg card-modern-input"
                                    v-model="store.state.card.account"
                                    v-bind:class="{
                                        'is-invalid': store.state.validation.accountHasError,
                                        'darkmode': darkMode,
                                    }"
                                >
                                    <option value="" selected disabled>{{ t('message.credit_cards.select_account') }}</option>
                                    <option v-for="(account, index) in store.state.accounts" :key="index"
                                        :value="account.id"
                                    >
                                        {{account.name}}
                                    </option>
                                </select>
                                <div id="cardAcountFeedback" class="invalid-feedback">
                                    {{ store.state.validation.accountMessageError }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-modern-section-card">
                        <div class="card-modern-section-head">
                            <h5>{{t('message.global.choose_icon')}}</h5>
                            <span>{{ store.state.card.name || 'Bandeira' }}</span>
                        </div>

                        <div class="card-modern-icons-scroll">
                            <div class="card-modern-icon-grid">
                                <button
                                    v-for="(icon, index) in store.state.icons" :key="index"
                                    type="button"
                                    @click="store.state.card.icon = icon.path"
                                    class="card-modern-icon-item"
                                    :class="{ 'is-active': store.state.card.icon == icon.path }"
                                    :title="icon.name"
                                >
                                    <img :src="icon.path" :alt="icon.name" class="rounded-5">
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="card-modern-footer">
                        <button
                            v-if="!store.state.savingCard"
                            @click="submitCard()"
                            class="btn card-modern-submit"
                        >
                            {{ store.state.card.id == '' ? t('message.credit_cards.add') : t('message.credit_cards.update') }}
                        </button>
                        <img v-if="store.state.savingCard" :src="loadGif" alt="" width="50">
                    </div>
                </div>
            </div>
        </div>
    </div>


<div class="modal fade" id="confirmarchiveCard" tabindex="-1" aria-labelledby="confirmarchiveCard" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content"  v-bind:class="{
                                            'darkmode': darkMode,
                                        }">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-11 mx-auto mt-4 mb-4">
                            <h5 class="mb-4">Você quer mesmo arquivar esse cartão?</h5>

                            <div class="col-12 text-center mt-3 mb-3">
                                <img :src="store.state.toArchive.icon" alt="" width="60" class="rounded">
                                <br>
                                <h4>{{store.state.toArchive.name}}</h4>
                            </div>

                            <div class="col-12 col-lg-10 mx-auto text-start mt-3 mb-3" v-html="t('message.credit_cards.archive_disclaim')">
                                
                            </div>

                        </div>
                        <div class="col-12 text-center">
                            <button
                                id="confirmarchiveCardButton" 
                                class="btn btn-success"
                            >
                                {{t('message.credit_cards.archive_button')}}
                            </button>

                            <a @click="closeModal('confirmarchiveCard')" class="btn btn-link">{{ t('message.global.cancel') }}</a>
                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="deleteCard" tabindex="-1" aria-labelledby="deleteCategoryModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="col-11 mx-auto mt-4 mb-4">
                        <h5 class="mb-4">{{ t('message.credit_cards.delete_title') }}</h5>

                        <div class="col-12 text-center mt-3 mb-3">
                            <img :src="store.state.toArchive.icon" alt="" width="60" class="rounded">
                            <br>
                            <h4>{{store.state.toArchive.name}}</h4>
                        </div>

                        <div class="col-12 col-lg-10 mx-auto text-start mt-3 mb-3" v-html="t('message.credit_cards.delete_disclaim')">
                            
                        </div>

                    </div>
                    <div class="col-12 text-center">
                        <button
                            id="confirmExclusionAccountButton" 
                            class="btn btn-danger"
                        >
                            {{ t('message.credit_cards.delete_button') }}
                        </button>

                        <a @click="closeModal('deleteCard')" class="btn btn-link">{{ t('message.global.cancel') }}</a>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

</template>

<style>

    .cards-premium-card{
        overflow: hidden;
        border-radius: 24px !important;
        background: #f6f3eb;
        box-shadow: 0 12px 40px rgba(24, 39, 75, 0.08);
    }

    .cards-premium-header{
        padding: 1.8rem 1.5rem 1.5rem;
        background: linear-gradient(135deg, #1f4876 0%, #224a78 55%, #1f436d 100%);
    }

    .cards-header-top{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 16px;
    }

    .cards-title-wrap{
        min-width: 0;
    }

    .cards-eyebrow{
        display: inline-block;
        margin-bottom: 10px;
        font-size: 0.92rem;
        color: rgba(255,255,255,0.78);
    }

    .cards-title{
        margin: 0;
        font-size: 2rem;
        line-height: 1.1;
        font-weight: 800;
        color: #ffffff;
    }

    .cards-subtitle{
        margin-top: 10px;
        color: rgba(255,255,255,0.66);
        font-size: 1rem;
    }

    .cards-header-actions{
        flex-shrink: 0;
    }

    .cards-add-btn{
        height: 52px;
        padding: 0 18px;
        border-radius: 16px;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        color: #fff !important;
        background: rgba(255,255,255,0.08);
        border: 1px solid rgba(255,255,255,0.14);
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.08);
        transition: all .2s ease;
        cursor: pointer;
        text-decoration: none;
        backdrop-filter: blur(6px);
    }

    .cards-add-btn:hover{
        transform: translateY(-1px);
        background: rgba(255,255,255,0.14);
        color: #fff !important;
    }

    .cards-premium-body{
        padding: 1.4rem !important;
        background: #f7f4ee;
    }

    .cards-surface{
        padding: 1rem 1rem .75rem;
        border-radius: 24px;
        background: rgba(255,255,255,0.62);
        border: 1px solid rgba(213, 205, 193, 0.5);
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.45);
    }

    .cards-list-wrap{
        display: flex;
        flex-direction: column;
        gap: .25rem;
    }

    .cards-empty-state{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: .85rem;
        min-height: 260px;
        border: 1px dashed rgba(17, 24, 39, 0.12);
        border-radius: 20px;
        background: linear-gradient(180deg, rgba(248, 247, 243, 0.7), #fff);
        color: #6f7b8c;
        text-align: center;
        padding: 1.5rem;
        margin: .5rem;
    }

    .cards-empty-state strong{
        display: block;
        color: #213E60;
        font-size: 1rem;
        margin-bottom: .2rem;
    }

    .cards-empty-icon{
        width: 66px;
        height: 66px;
        border-radius: 18px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 1.45rem;
        color: #d89239;
        background: rgba(216, 146, 57, 0.12);
    }

    .card-modern-modal-dialog {
        max-width: 760px;
    }

    .card-modern-modal-content {
        border: none;
        border-radius: 26px;
        overflow: hidden;
        background: #f8f7f3;
        box-shadow: 0 24px 70px rgba(15, 23, 42, 0.18);
    }

    .card-modern-modal-body {
        padding: 1.2rem !important;
        max-height: calc(100vh - 2rem);
        overflow-y: auto;
        overflow-x: hidden;
        background: linear-gradient(180deg, #fcfcfa 0%, #f7f5ef 100%);
        -webkit-overflow-scrolling: touch;
    }

    .card-modern-modal-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem;
        margin-bottom: 1rem;
    }

    .card-modern-modal-eyebrow {
        color: #7183a1;
        font-size: 0.88rem;
        font-weight: 700;
        margin-bottom: 0.25rem;
    }

    .card-modern-modal-title {
        margin: 0;
        color: #213E60;
        font-size: 1.7rem;
        font-weight: 800;
        line-height: 1.1;
    }

    .card-modern-modal-subtitle {
        margin: 0.45rem 0 0;
        color: #6b7c93;
        font-size: 0.96rem;
    }

    .card-modern-close {
        width: 42px;
        height: 42px;
        min-width: 42px;
        border: 1px solid #d7e0ea;
        border-radius: 14px;
        background: #ffffff;
        color: #607392;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all .2s ease;
    }

    .card-modern-close:hover {
        transform: translateY(-1px);
        background: #eef4fb;
        border-color: #a8bfd9;
    }

    .card-modern-preview-card,
    .card-modern-form-card,
    .card-modern-section-card {
        background: rgba(255,255,255,0.88);
        border: 1px solid #dbe5f0;
        border-radius: 22px;
        box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
    }

    .card-modern-preview-card {
        display: flex;
        align-items: center;
        gap: 0.95rem;
        padding: 1rem 1.05rem;
        margin-bottom: 1rem;
    }

    .card-modern-preview-icon {
        width: 72px;
        height: 72px;
        min-width: 72px;
        border-radius: 20px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 22px rgba(15, 23, 42, 0.10);
        padding: 10px;
    }

    .card-modern-preview-icon img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .card-modern-preview-text {
        display: flex;
        flex-direction: column;
        gap: 0.18rem;
        min-width: 0;
    }

    .card-modern-preview-label {
        color: #7183a1;
        font-size: 0.86rem;
        font-weight: 700;
    }

    .card-modern-preview-text strong {
        color: #213E60;
        font-size: 1.02rem;
        font-weight: 800;
        word-break: break-word;
    }

    .card-modern-preview-text small {
        color: #6b7c93;
        font-size: 0.86rem;
    }

    .card-modern-form-card {
        padding: 1rem;
        margin-bottom: 1rem;
    }

    .card-modern-label {
        display: block;
        margin-bottom: 0.45rem;
        color: #344766;
        font-weight: 700;
        font-size: 0.95rem;
    }

    .card-modern-input {
        min-height: 54px !important;
        border-radius: 15px !important;
        border: 1px solid #d7e0ea !important;
        background: #ffffff !important;
        box-shadow: none !important;
        color: #344766;
    }

    .card-modern-input:focus {
        border-color: #8aa8ca !important;
        box-shadow: 0 0 0 4px rgba(138, 168, 202, 0.14) !important;
    }

    .card-modern-input::placeholder {
        color: #9aa8bb;
    }

    .card-modern-section-card {
        padding: 1rem;
        margin-bottom: 1rem;
    }

    .card-modern-section-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.75rem;
        margin-bottom: 0.9rem;
    }

    .card-modern-section-head h5 {
        margin: 0;
        color: #344766;
        font-size: 1rem;
        font-weight: 800;
    }

    .card-modern-section-head span {
        color: #6b7c93;
        font-size: 0.8rem;
        background: #f3f7fb;
        padding: 0.36rem 0.68rem;
        border-radius: 999px;
    }

    .card-modern-icons-scroll {
        max-height: 260px;
        overflow-y: auto;
        padding-right: 0.2rem;
    }

    .card-modern-icon-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(64px, 1fr));
        gap: 0.7rem;
    }

    .card-modern-icon-item {
        height: 60px;
        border-radius: 16px;
        border: 1px solid #d7e0ea;
        background: #f8fafc;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        transition: all .2s ease;
    }

    .card-modern-icon-item:hover {
        background: #eef4fb;
        border-color: #9fbad8;
        transform: translateY(-1px);
    }

    .card-modern-icon-item.is-active {
        background: #ffffff;
        border-color: #213E60;
        box-shadow: 0 0 0 4px rgba(33, 62, 96, 0.12);
    }

    .card-modern-icon-item img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .card-modern-footer {
        position: sticky;
        bottom: 0;
        z-index: 3;
        padding-top: 0.1rem;
        text-align: center;
    }

    .card-modern-submit {
        width: 100%;
        min-height: 52px;
        border: none !important;
        border-radius: 15px !important;
        background: linear-gradient(135deg, #d89239 0%, #c97d24 100%) !important;
        color: #ffffff !important;
        font-weight: 800 !important;
        box-shadow: 0 18px 34px rgba(201, 125, 36, 0.24);
    }

    .card-modern-submit:hover,
    .card-modern-submit:focus {
        transform: translateY(-1px);
        color: #ffffff !important;
        background: linear-gradient(135deg, #e09a40 0%, #cf8024 100%) !important;
    }

    .account-create-icon-div{
        height: 50px;
    }

    .account-create-icon{
        min-height: 100%;
    }

    .icon-picker{
        margin: 2px 4px 2px 0;
        width: 60px !important;
        height: 60px !important;
        cursor: pointer;
    }

    .icon-picker img {
        width: 100%;
        border-radius: 0.25rem
    }

    .icon-create{
        font-size: 30px;
    }

    .icon-list{
        height: 150px;
        overflow-x:auto;
    }

    .cursor-pointer{
        cursor: pointer;
    }

    @media (max-width: 991.98px) {
        .cards-premium-header{
            padding: 1.3rem 1rem 1.2rem;
        }

        .cards-header-top{
            flex-direction: column;
            align-items: stretch;
        }

        .cards-title{
            font-size: 1.65rem;
        }

        .cards-add-btn{
            width: 100%;
            justify-content: center;
        }

        .cards-premium-body{
            padding: 1rem !important;
        }
    }

    @media (max-width: 575.98px) {
        .cards-premium-card{
            border-radius: 20px !important;
        }

        .cards-title{
            font-size: 1.35rem;
        }

        .cards-subtitle{
            font-size: .9rem;
        }

        .cards-surface{
            border-radius: 18px;
            padding: .75rem .5rem;
        }

        .cards-empty-state{
            min-height: 190px;
            border-radius: 16px;
            padding: 1.25rem;
        }

        .card-modern-modal-dialog {
            margin: 0.5rem;
        }

        .card-modern-modal-body {
            padding: 0.9rem !important;
            max-height: calc(100vh - 1rem);
        }

        .card-modern-modal-title {
            font-size: 1.3rem;
        }

        .card-modern-preview-card {
            padding: 0.85rem;
        }

        .card-modern-preview-icon {
            width: 58px;
            height: 58px;
            min-width: 58px;
            border-radius: 16px;
        }

        .card-modern-section-head {
            align-items: flex-start;
            flex-direction: column;
        }

        .card-modern-icon-grid {
            grid-template-columns: repeat(auto-fill, minmax(56px, 1fr));
            gap: 0.55rem;
        }

        .cards-premium-card{
          margin-bottom: 60px;
        }
    }
</style>